<template>
  <div>
    <p class="desc">选择能发起该审批的人员，不选则默认开放给所有人</p>
    <el-button size="mini" @click="selectOrg" icon="el-icon-plus" type="primary" round>请选择</el-button>
    <org-items v-model="select" />
    <tree
      @update="closeTree"
      @sendList="getSelectList($event)"
      :open="open"
      :list="selectList"
      v-if="open"
      :companyId="EId"
      :url="url"
    ></tree>

    <zhTree
      @update="closeTree"
      @sendList="getSelectList($event)"
      :open="zhTreeOpen"
      :list="selectList"
      v-if="zhTreeOpen"
      :companyId="EId"
      :url="url"
    ></zhTree>
    <!-- <org-picker title="请选择可发起本审批的人员/部门" multiple ref="orgPicker" :selected="select" @ok="selected"/> -->
  </div>
</template>

<script>
import { insertClockInPersonnel, getUserListByManagementId } from '@/api/Industry'
import tree from '../../../shop/tree.vue'
import zhTree from '../../../shop/zhTree.vue'
import OrgPicker from '@/components/common/OrgPicker'
import OrgItems from '../OrgItems'

export default {
  name: 'RootConfig',
  components: { OrgPicker, OrgItems, tree, zhTree },
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      showOrgSelect: false,
      open: false,
      zhTreeOpen: false,
      selectList: [], // 勾选人员数组
      EId: this.$route.query.EId,
      url: this.$route.query.url,
      platformId: this.$route.query.platformId,
    }
  },
  computed: {
    select() {
      return this.config.assignedUser
    },
  },
  methods: {
    openTree() {
      console.log(this.open, 'this.open')
      this.open = true
    },
    closeTree() {
      this.open = false
      this.zhTreeOpen = false
    },
    // 接收 子组件传递过来 的勾选人员数组
    getSelectList(list) {
      console.log(list, 'list')
      this.select.length = 0
      list.forEach((val) => this.select.push(val))
      this.selectList = list
      var arr = []
      list.forEach((i) => {
        arr.push(i.name)
      })
      console.log(arr, 'arr')
      this.peopleList = arr
    },
    // 获取 考勤组人员
    async getUserListByManagementId() {
      const res = await getUserListByManagementId({
        managementId: this.managementId,
      })
      if (res.code == 200) {
        console.log(res.data)
        this.selectList = res.data
      }
    },
    async submitForm() {
      this.PeopleLoading = true
      const res = await insertClockInPersonnel({
        item: this.selectList,
        managementId: this.managementId,
        platformId: this.platformId,
      })
      if (res) {
        if (res.code == 200) {
          this.People = false
          this.$message({
            type: 'success',
            message: '设置成功',
          })
          this.PeopleLoading = false
          this.getUserListByManagementId()
        }
      } else {
        this.PeopleLoading = false
      }
    },
    selectOrg() {
      // this.$refs.orgPicker.show()
      console.log(this.$route.query.platformId)
      if (this.$route.query.platformId == 'shenpi') {
        this.open = true
      } else {
        this.zhTreeOpen = true
        console.log(111233)
      }
    },
    selected(select) {
      this.select.length = 0
      select.forEach((val) => this.select.push(val))
    },
    removeOrgItem(index) {
      this.select.splice(index, 1)
    },
  },
}
</script>

<style lang="less" scoped>
.desc {
  font-size: small;
  color: #8c8c8c;
}
.org-item {
  margin: 5px;
}
</style>
